	<!--
	TEMPLATE
-->
<template>
<div class="editable-photos">
	<div v-if="!isEditView">{{ images ? images.length : 0 }} {{ images && images.length === 1 ? itemLabel : itemLabel + 's' }}</div>

	<!-- Photo grid -->
	<div v-if="isEditView" class="editable-photos__photo-grid">
		<!-- Photos -->
		<draggable class="editable-photos__photo-grid--draggable" v-model="images" :list="images">
			<div v-for="(image, index) in images" class="editable-photos__photo" :class="{'editable-photos__photo--main': index === 0}" :style="{backgroundImage: 'url('+s3url(image, 'small')+')'}">
				<span class="editable-photos__remove-btn" @click="remove(index)"><i class="ico ico-delete"></i></span>
			</div>
		</draggable>

		<s3 v-model="images" :label="'Add ' + itemLabel + 's'"></s3>
	</div>

	</div>
</template>

<!--
	SCRIPT
-->
<script>
import utils from '@/libs/mixins.js';
import vModelNested from '@/libs/vModelNested.js';
import S3 from '../../components/S3.vue';
import draggable from 'vuedraggable';

export default {
	props: {
		value: {
			type: Array,
			default: function() {
				return []
			}
		},
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
			newPhotos: [],
		}
	},
	mixins: [utils],
	components: {
		's3': S3,
		'draggable': draggable
	},
	computed: {
		images: vModelNested,
		itemLabel: function () {
			if(this.options && this.options.itemLabel) {
				return this.options.itemLabel;
			} else {
				return 'photo';
			}
		}
	},
	methods: {
		remove: function(index) {
			if (confirm('Are you sure you want to delete this photo?')) {
				this.images.splice(index, 1);
			}
		}
	}
}
</script>
